import React from 'react';
import { Link } from 'react-router-dom';
import ButtonPrimary from '../buttons/ButtonPrimary';

const LoginFloatbar = () => {

    return (
        <div className="d-flex flex-column">
            <span className="d-block text-center">Want to track your learning progress?</span>
            <div className="auth-buttons justify-content-center">
                <Link to='/login'>
                    <ButtonPrimary type="submit" value="Login" fontSize="14px" padding="0px 15px" height="30px" className="tkmr-btn-auto-fit" />
                </Link>
                <span className="mx-1">or</span>
                <Link to='/login?register=true'>
                    <ButtonPrimary type="submit" value="Register" fontSize="14px" padding="0px 15px" height="30px" className="tkmr-btn-auto-fit" />
                </Link>
            </div>
        </div>
    );
};

export default LoginFloatbar;